
import base from './base'; // 导入接口域名列表
import axios from "../common/axios";
import qs from 'qs'; // 根据需求是否导入qs模块

const shopkeeper = {
  //获取Rnd活动信息
  getRndActivityInfo(id) {
    return axios.get('http://101.35.51.201/activities/api/activities/baseInfo/getInfoById/?id=' + id)
  },
  //获取门店地址信息
  getStoreAddress(params){
    return axios.post(`${base.sq}/gateway/product/wxPay/getStoreAddress`,params);
  },
  //getRndAccessToken
  getRndAccessToken(params){
    return axios.post(`${base.sq}/gateway/product/wxPay/getAccessToken`,params);
  },
  //RND微信支付
  fieldRndOrder(params){
    return axios.post(`${base.sq}/gateway/product/wxPay/fieldOrder`,params);
  },
  //获取疗程列表
  getProductInfoPage(params) {
    return axios.post(`${base.sq}/gateway/product/getProductSalesInfoPage`, params)
  },
    //获取追溯产品信息
  getRetroactiveGoodsByUniCode(params) {
    return axios.post(`${base.sq}/gateway/product/getRetroactiveGoodsByUniCode`, params)
  },
   //获取追溯产品订单信息
   getRetroactiveGoodsOrder(params) {
    return axios.post(`${base.sq}/gateway/product/getRetroactiveGoodsOrder`, params)
  },
 //获取追溯产品订单同期产品信息
   getRetroactiveInfoByUniCode(params) {
    return axios.post(`${base.sq}/gateway/product/getRetroactiveInfoByUniCode`, params)
  },
  //新增加盟城市信息
  insertStoreJoinInfo(params) {
    return axios.post(`${base.sq}/gateway/shop/insertStoreJoinInfo`, params)
  },
  //新增加盟城市信息--来源统计
  insertStoreJoinCount(params) {
    return axios.post(`${base.sq}/gateway/shop/insertStoreJoinCount`, params)
  },
  //百度埋点
  sendPostBaidu(params) {
    return axios.post(`${base.sq}/gateway/shop/sendPostBaidu`, params)
  },
     //更新门店坐标
  updateStoreInfo(params) {
    return axios.post(`${base.sq}/gateway/shop/updateStoreInfo`, params)
  },
  //获取疗程列表
  getCardGoodsList(params) {
    return axios.post(`${base.sq}/gateway/card/getCardGoodsList`, params)
  },
    // 卡列表
    cardList(params) {
        return axios.post(`${base.sq}/gateway/membership/getAllUserListByOpenId`, params)
    },
        //小程序 卡列表
    assCardList(params) {
        return axios.post(`${base.sq}/gateway/membership/getAllUserListByOpenIdForAss`, params)
    },
    // 会员列表
    memberList(params){
         return axios.post(`${base.sq}/gateway/membership/getMemberBaseInfoBeanList`,params);
    },
    //笔记列表
    noteList(params){
         return axios.post(`${base.sq}/gateway/membership/getMemberNotesBeanPages`,params);
    },
    //添加笔记
    addNote(params){
         return axios.post(`${base.sq}/gateway/membership/addMemberNotesBean`,params);
    },
    //修改预约信息
  updateEmployeeBookingInfo(params){
         return axios.post(`${base.sq}/gateway/shop/updateEmployeeBookingInfoMobile`,params);
    },
   //预约记录
    bookingList(params){
         return axios.post(`${base.sq}/gateway/shop/getEmployeeBookingInfoByList`,params);
    },
    //预约设置信息
    getBookingSettingInfo(params){
         return axios.post(`${base.sq}/gateway/shop/getBookingSettingInfo`,params);
    },
     //用户预约记录
     userBookingList(params){
          return axios.post(`${base.sq}/gateway/shop/getUserBookingList`,params);
          // return axios.post(`${base.sq}/getUserBookingList`,params);
     },
     //用户预约记录详情
     getUserBookingDetail(params){
          return axios.post(`${base.sq}/gateway/shop/getUserBookingDetail`,params);
     },
    //登录
    login(params){
        return axios.post(`${base.sq}/gateway/membership/userLogin`,params);
    },
    //获取店长商城链接
    getShopUrl(params){
         return axios.post(`${base.sq}/gateway/membership/getGenerateUrl`,params);
    },
    //获取首页业绩数据
    getMonthSalesReport(params){
         return axios.post(`${base.sq}/gateway/cashier/getMonthSalesReport`,params);
    },
    //获取门店业绩/卡耗
    storeEmployeeSales(params){
         return axios.post(`${base.sq}/gateway/cashier/getOrderEmployeeSales`,params);
    },
    //产品、疗程、卡项销售业绩
    getGoodsReport(params){
         return axios.post(`${base.sq}/gateway/cashier/getResultGoodsReportPages`,params);
    },
    //拓客二维码
    getEmployeeInfoQrcode(params){
         return axios.post(`${base.sq}/gateway/membership/getEmployeeInfoQrcode`,params);
    },
     //拓客合成二维码
    getEmployeeInfoMergeQrcode(params){
         return axios.post(`${base.sq}/gateway/membership/getEmployeeQrcodeMergeImg`,params);
    },
    //拓客小程序二维码
    getAssQrcodeByStoreCode(params){
         return axios.post(`${base.sq}/gateway/assistant/token/getAssQrcodeByStoreCode`,params);
    },
    //获取活动报表
    getActivityInfoReport(params){
         return axios.post(`${base.sq}/gateway/shop/getActivityInfoReportForm`,params);
    },
    //会员报表
    getConsumptionReport(params){
         return axios.post(`${base.sq}/gateway/membership/getConsumptionReportBean`,params);
    },
    //会员消费报表明细
    getResultMemberConsumption(params){
         return axios.post(`${base.sq}/gateway/membership/getResultMemberConsumptionPages`,params);
    },
    //来店情况会员报表
    getMemberLastService(params){
         return axios.post(`${base.sq}/gateway/membership/getMemberLastServiceBeanPages`,params);
    },
    //查询短信发送模板
    getMemberSmsTemplate(params){
         return axios.post(`${base.sq}/gateway/shop/getMemberSmsTemplateInfoByList`,params);
    },
    //查询短信发送模板
    getMemberSmsTemplate(params){
        return axios.post(`${base.sq}/gateway/shop/getMemberSmsTemplateInfoByList`,params);
    },
    //发送关怀短信
    sendShopTemplateMeaage(params){
        return axios.post(`${base.sq}/gateway/shop/sendShopTemplateMeaageInfo`,params);
    },
    //查询关怀短信发送记录
    getSendTemplateGroupByDatePages(params){
        return axios.post(`${base.sq}/gateway/shop/getSendTemplateGroupByDatePages`,params);
    },
    //发送产品疗程卡项销售业绩报表 （邮箱）
    sendGoodsReportEmail(params){
        return axios.post(`${base.sq}/gateway/membership/getSendGoodsReportEmail`,params);
    },
    //发送会员消费报表（邮箱）
    sendMemberConsumptionEmail(params){
        return axios.post(`${base.sq}/gateway/membership/getSendMemberConsumptionEmail`,params);
    },
    //个人账户
   account(params) {
        return axios.post('https://storeapp.chlitina.com.cn/mobile/invoice.php?act=invoice', params,{
              headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        })
   },
   //添加员工
    addEmployeeInfoBean(params){
        return axios.post(`${base.sq}/gateway/membership/addEmployeeInfoBean`,params);
    },
    //添加员工同步到教务系统
   v3_to_jiaowu(params) {
        return axios.post('https://storeapp.chlitina.com.cn/mobile/mystaff.php?act=v3_to_jiaowu', params,{
              headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        })
   },
   //员工列表
    myStaffList(params){
        return axios.post(`${base.sq}/gateway/membership/getEmployeeInfoBeanPages`,params);
    },
    //修改员工
    updateEmployeeInfoBean(params){
        return axios.post(`${base.sq}/gateway/membership/updateEmployeeInfoBean`,params);
    },
  //获取云店实物订单信息
  productList(params){
    return axios.post(`${base.sq}/gateway/shop/getMWechatProductInfoByList`,params);
  },
    //获取附近的店铺列表
  getStoreList(params){
    return axios.post(`${base.sq}/gateway/shop/getStoreListByMobile`,params);
  },
  //获取云店实物订单明细
  productDetail(params){
    return axios.post(`${base.sq}/gateway/shop/getMWechatProductDetailList`,params);
  },

    getEmployeeBookingByEmployeeCode(params) {
      return axios.post(`${base.sq}/gateway/shop/getEmployeeBookingByEmployeeCode`,params);
    },
    //获取微信配置
    getWeixinConfig(params){
        return axios.post(`${base.sq}/gateway/membership/getJsapiTicketSing`,params);
    },
    //获取企业微信配置
    getCpWeixinConfig(params){
        return axios.post(`${base.sq}/gateway/product/getCpJsapiTicketSing`,params);
    },
    //天猫券码核销
   tmallTicketCodeUse(params) {
        return axios.post(`${base.sq}/gateway/assistant/coupon/tmallTicketCodeUse`,params);
   },
       //美团点评券码核销
       mtVerificationReceiptPrepare(params) {
          return axios.post(`${base.sq}/gateway/assistant/coupon/mtVerificationReceiptPrepare`,params);
     },
       //云店礼品卡券券码核销
     callAssistanGiftCardVoucherVerification(params) {
          return axios.post(`${base.sq}/gateway/assistant/coupon/callAssistanGiftCardVoucherVerification`,params);
     },
       //抖音团购券券码核销
       douYinTicketCodeUse(params) {
          return axios.post(`${base.sq}/gateway/assistant/coupon/douYinTicketCodeUse`,params);
     },
   //口碑券码核销
    koubeiTicketCodeUse(params){
        return axios.post(`${base.sq}/gateway/assistant/coupon/koubeiTicketCodeUse`,params);
    },
    //贵宾体验券
    experienceTicketCodeUse(params){
        return axios.post(`${base.sq}/gateway/assistant/coupon/experienceTicketCodeUse`,params);
    },
    //瑞鲨小程序预约核销
    callAssistanWriteOffInfo(params){
        return axios.post(`${base.sq}/gateway/assistant/coupon/callAssistanWriteOffInfo`,params);
    },
      ///阿里系券
    aliTicketCodeUse(params){
        return axios.post(`${base.sq}/gateway/assistant/coupon/aliTicketCodeUse`,params);
    },
    ///白衣守护券码核销
    couponAssistanWriteOff(params){
        return axios.post(`${base.sq}/gateway/assistant/coupon/couponAssistanWriteOff`,params);
    },
    //微信支付
    fieldOrder(params){
      return axios.post(`${base.sq}/gateway/assistant/wxPay/fieldOrder`,params);
    },
    //check门店活动信息
    checkActivityInfo(params){
      return axios.post(`${base.sq}/gateway/assistant/wxPay/checkActivityInfo`,params);
    },
    //check门店活动信息
    checkStoreInfo(params){
      return axios.post(`${base.sq}/gateway/assistant/wxPay/checkStoreInfo`,params);
    },
    //getAccessToken
    getAccessToken(params){
      return axios.post(`${base.sq}/gateway/assistant/wxPay/getAccessToken`,params);
    },
    getYMPoints(storeCode) {
      return axios.get('https://storeapp.chlitina.com.cn/mobile/ymPoints.php?act=getAccountInfo&storeCode=' + storeCode)
    },
    getYMPointsList(storeCode) {
      return axios.get('https://storeapp.chlitina.com.cn/mobile/ymPoints.php?act=getDetail&storeCode=' + storeCode)
    },
    getYMCashOutList(storeCode) {
      return axios.get('https://storeapp.chlitina.com.cn/mobile/ymPoints.php?act=getCashOutList&storeCode=' + storeCode)
    },
    addPointsCashOut(params) {
      return axios.post(`${base.sq}/gateway/membership/addYmPointsImgBeanFunction`, params);
    },
    updateYmPointsImg(params) {
      return axios.post(`${base.sq}/gateway/membership/updateYmPointsImgBeanFunction`, params);
    },
    updateYmPoints(params) {
      return axios.post(`${base.sq}/gateway/membership/updateYmPointsCashOutBeanFunction`, params);
    },
    YMPointsCashOut(params) {
      return axios.post('https://storeapp.chlitina.com.cn/mobile/ymPoints.php?act=cashOut', params);
    },
    YMUpdatePointsCashOut(params) {
      return axios.post('https://storeapp.chlitina.com.cn/mobile/ymPoints.php?act=updateCashOut', params);
    },
    getYMPoints(storeCode) {
      return axios.get('https://storeapp.chlitina.com.cn/mobile/ymPoints.php?act=getAccountInfo&storeCode=' + storeCode)
    },
    getYMPointsList(storeCode) {
      return axios.get('https://storeapp.chlitina.com.cn/mobile/ymPoints.php?act=getDetail&storeCode=' + storeCode)
    }
}

export default shopkeeper;




// WEBPACK FOOTER //
// ./src/service/shopkeeper.js